import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import { toast } from 'react-toastify';
import './Login.css';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      toast.error('Introduza o seu email');
      return;
    }

    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
      toast.success('Email enviado com sucesso!');
    } catch (error) {
      toast.error('Erro ao enviar email. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="login-container">
        <div className="login-box">
          <div className="login-header">
            <h1>📧 Email Enviado</h1>
            <p>Se o email existir na nossa base de dados, receberá instruções para redefinir a sua password.</p>
            <p style={{ marginTop: '20px' }}>Verifique também a pasta de spam.</p>
          </div>
          <div className="login-footer">
            <Link to="/login">Voltar ao Login</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-header">
          <h1>🔑 Recuperar Password</h1>
          <p>Introduza o seu email para receber instruções</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="seu.email@exemplo.com"
            />
          </div>

          <button type="submit" className="login-button" disabled={loading}>
            {loading ? 'A enviar...' : 'Enviar Email'}
          </button>
        </form>

        <div className="login-footer">
          <Link to="/login">Voltar ao Login</Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
